import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./utils/ProtectedRoute.js";
import PermissionGuard from "./utils/PermissionGuard.js";

// Admin Layout
import AdminLoginPage from "./pages/backend/AdminLoginPage.jsx";
import Dashboard from "./pages/backend/Dashboard.jsx";
import FacebookPixels from "./pages/backend/FacebookPixels.jsx";
import GoogleSiteSetups from "./pages/backend/GoogleSiteSetups.jsx";
import PaymentGeteways from "./pages/backend/PaymentGeteways.jsx";
import ChatDatas from "./pages/backend/ChatDatas.jsx";
import Domain from "./pages/backend/Domain.jsx";
import ThemeCustomizables from "./pages/backend/ThemeCustomizables.jsx";
import Settings from "./pages/backend/Settings.jsx";

import Orders from "./pages/backend/Orders.jsx";
import Products from "./pages/backend/Products.jsx";
import Customers from "./pages/backend/Customers.jsx";
import SeoPage from "./pages/backend/SeoPage.jsx";
import AdditionalPages from "./pages/backend/AdditionalPages.jsx";
import LandingForm from "./pages/backend/LandingForm.jsx";
import Landings from "./pages/backend/Landings.jsx";
import Categories from "./pages/backend/Categories.jsx";
import Tags from "./pages/backend/Tags.jsx";
import Brands from "./pages/backend/Brands.jsx";
import SubCategories from "./pages/backend/SubCategories.jsx";
import ChildCategories from "./pages/backend/ChildCategories.jsx";
import ProductForm from "./pages/backend/ProductForm.jsx";
import Coupons from "./pages/backend/Coupons.jsx";
import Carousels from "./pages/backend/Carousels.jsx";
import Banners from "./pages/backend/Banners.jsx";
import ExpenseCategories from "./pages/backend/ExpenseCategories.jsx";
import Expenses from "./pages/backend/Expenses.jsx";
import Admins from "./pages/backend/Admins.jsx";
import WhyShopOnlineWithUs from "./pages/backend/WhyShopOnlineWithUs.jsx";
import OnlinePaymentMethods from "./pages/backend/OnlinePaymentMethods.jsx";
import AfterSalesSupport from "./pages/backend/AfterSalesSupport.jsx";
import FAQ from "./pages/backend/FAQ.jsx";
import ReturnRefundPolicy from "./pages/backend/ReturnRefundPolicy.jsx";
import PrivacyPolicy from "./pages/backend/PrivacyPolicy.jsx";
import TermsAndConditions from "./pages/backend/TermsAndConditions.jsx";
import AboutUs from "./pages/backend/AboutUs.jsx";
import OrderForm from "./pages/backend/OrderForm.jsx";
import OrderDetails from "./pages/backend/OrderDetails.jsx";
import Forbidden from "./pages/backend/Forbidden.jsx";
import BackendLayout from "./components/backend/BackendLayout.jsx";
import LandingPageVvvebBuilder from "./pages/backend/LandingPageVvvebBuilder.jsx";

// Frontend Layout
// import FullPage from "./components/frontend/FullPage.jsx";
import Layout from "./components/frontend/Layout.jsx";
import HomePage from "./pages/frontend/HomePage.jsx";
import Register from "./pages/frontend/Register.jsx";
import ReadyThemes from "./pages/backend/ReadyThemes.jsx";
import Wishlist from "./pages/frontend/Wishlist.jsx";
import Cart from "./pages/frontend/Cart.jsx";
import Checkout from "./pages/frontend/Checkout.jsx";
import Payment from "./pages/frontend/Payment.jsx";
import About from "./pages/frontend/About.jsx";
import Ticket from "./pages/frontend/Ticket.jsx";
import WhyShopOnlinewithUsFront from "./pages/frontend/WhyShopOnlinewithUsFront.jsx";
import AfterSalesSupportFront from "./pages/frontend/AfterSalesSupportFront.jsx";
import FAQFront from "./pages/frontend/FAQFront.jsx";
import PrivacyPolicyFront from "./pages/frontend/PrivacyPolicyFront.jsx";
import TermsandConditionsFront from "./pages/frontend/TermsandConditionsFront.jsx";
import OnlinePaymentMethodsFront from "./pages/frontend/OnlinePaymentMethodsFront.jsx";
import IncomeCategories from "./pages/backend/IncomeCategories.jsx";
import Incomes from "./pages/backend/Incomes.jsx";
// import Order_Incomplete from "./pages/backend/Order_Incomplete.jsx";
import OrderPayments from "./pages/backend/OrderPayments.jsx";
import TicketCategories from "./pages/backend/TicketCategories.jsx";
import Tickets from "./pages/backend/Tickets.jsx";
import Couriers from "./pages/backend/Couriers.jsx";

import Contact from "./pages/frontend/Contact.jsx";
import RefundPolicyFront from "./pages/frontend/RefundPolicyFront.jsx";
import BlogDetail from "./components/frontend/BlogDetail.jsx";
import PostDetail from "./components/frontend/PostDetail.jsx";
import Posts from "./pages/backend/Posts.jsx";
import PostForm from "./pages/backend/PostForm.jsx";
import Bookings from "./pages/backend/Bookings.jsx";
import ChatDashboard from "./components/frontend/ChatDashboard.jsx";
import PaymentGateway from "./components/frontend/PaymentGateway.jsx";
import SearchPage from "./components/frontend/SearchPage.jsx";
import ChatDashboardHost from "./components/frontend/ChatDashboardHost.jsx";
import PaymentSuccess from "./components/frontend/PaymentSuccess.jsx";
import PaymentFailed from "./components/frontend/PaymentFailed.jsx";
import PaymentCancel from "./components/frontend/PaymentCancel.jsx";
import Facilities from "./pages/backend/Facilities.jsx";
import Comments from "./pages/backend/Comments.jsx";
import Addresses from "./pages/backend/Addresses.jsx";
import AccountDashboard from "./components/frontend/AccountDashboard.jsx";
import MyBookings from "./components/frontend/MyBookings.jsx";
import Notification from "./components/frontend/Notification.jsx";
import Blogs from "./pages/backend/Blogs.jsx";
import Careers from "./pages/backend/Careers.jsx";
import Faqs from "./pages/backend/Faqs.jsx";
import News from "./pages/backend/News.jsx";
import Investors from "./pages/backend/Investors.jsx";
import InvestorProjects from "./pages/backend/InvestorProjects.jsx";
import Notifications from "./pages/backend/Notifications.jsx";
import Testimonials from "./pages/backend/Testimonials.jsx";
import BlogList from "./pages/frontend/BlogList.jsx";
import ProfileView from "./components/frontend/ProfileView.jsx";
import HomeSearchBarMobile from "./components/frontend/HomeSearchBarMobile.jsx";
import SearchResultMobile from "./components/frontend/SearchResultMobile.jsx";
import MyListing from "./components/frontend/MyListing.jsx";
import PostDetailMobile from "./components/frontend/PostDetailMobile.jsx";
import Calendar from "./components/frontend/Calendar.jsx";
import Reservation from "./components/frontend/Reservation.jsx";
import ProfileMobile from "./components/frontend/ProfileMobile.jsx";
import PaymentHistory from "./components/frontend/PaymentHistory.jsx";
import Facility from "./components/frontend/Facilities.jsx";
import HostProfile from "./components/frontend/HostProfile.jsx";

function App() {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="listing/:id" element={<PostDetail />}/>
          <Route path="host-profile/:id" element={<HostProfile />}/>
          <Route path="listingmobile/:id" element={<PostDetailMobile />}/>
          <Route path="blogs" element={<BlogList />} />
          <Route path="blog/:id" element={<BlogDetail />} />
          <Route path="chat" element={<ChatDashboard />} />
          <Route path="chats" element={<ChatDashboardHost />} />
          <Route path="payment/:id" element={<PaymentGateway />} />
          <Route path="payment-success/:id" element={<PaymentSuccess />} />
          <Route path="payment-failed/:id" element={<PaymentFailed />} />
          <Route path="payment-cancel/:id" element={<PaymentCancel />} />
          <Route path="facility/:id" element={<Facility />} />

          <Route path="/q" element={<SearchPage />} />

          <Route path="payment" element={<Payment />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="RefundPolicy" element={<RefundPolicyFront />} />
          <Route path="PrivacyPolicy" element={<PrivacyPolicyFront />} />
          <Route path="TermsandConditions" element={<TermsandConditionsFront />} />

          <Route path="dashboard" element={<AccountDashboard />} />
          <Route path="profile" element={<ProfileView />} />
          <Route path="profilemobile" element={<ProfileMobile />} />
          <Route path="paymenthistory" element={<PaymentHistory />} />
          <Route path="calendar" element={<Calendar />} />
          <Route path="reservation" element={<Reservation />} />
          <Route path="homesearchbarmobile" element={<HomeSearchBarMobile />} />
          <Route path="searchresultmobile" element={<SearchResultMobile />} />
          <Route path="mylisting" element={<MyListing />} />
          <Route path="booking" element={<MyBookings />} />
          <Route path="notification" element={<Notification />} />
          <Route path="wishlist" element={<Wishlist />} />
          <Route path="cart" element={<Cart />} />
          <Route path="register" element={<Register />} />
          <Route path="checkout" element={<Checkout />} />
          <Route path="about" element={<About />} />
          <Route path="ticket" element={<Ticket />} />

          <Route path="WhyShopOnlinewithUs" element={<WhyShopOnlinewithUsFront />} />
          <Route path="OnlinePaymentMethods" element={<OnlinePaymentMethodsFront />} />
          <Route path="AfterSalesSupport" element={<AfterSalesSupportFront />} />
          <Route path="FAQ" element={<FAQFront />} />
          
        </Route>
     
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="admin/*" element={
          <ProtectedRoute>
            <BackendLayout />
          </ProtectedRoute>
        }>
          <Route path="dashboard" element={<PermissionGuard permissionKey="dashboard"><Dashboard /></PermissionGuard>} />
          
          <Route path="orders" element={<PermissionGuard permissionKey="orders"><Orders /></PermissionGuard>} />
          <Route path="order/add" element={<PermissionGuard permissionKey="orders"><OrderForm /></PermissionGuard>} />
          <Route path="order/details/:id" element={<PermissionGuard permissionKey="orders"><OrderDetails /></PermissionGuard>} />
          <Route path="order/edit/:id" element={<PermissionGuard permissionKey="orders"><OrderForm /></PermissionGuard>} />
          <Route path="order/payments/:id" element={<PermissionGuard permissionKey="orders"><OrderPayments /></PermissionGuard>} />
          
          <Route path="couriers" element={<PermissionGuard permissionKey="orders"><Couriers /></PermissionGuard>} />
          <Route path="tickets" element={<PermissionGuard permissionKey="orders"><Tickets /></PermissionGuard>} />
          <Route path="ticket_category" element={<PermissionGuard permissionKey="orders"><TicketCategories /></PermissionGuard>} />
          
          <Route path="posts" element={<PermissionGuard permissionKey="posts"><Posts /></PermissionGuard>} />
          <Route path="post_form" element={<PermissionGuard permissionKey="posts"><PostForm /></PermissionGuard>} />
          <Route path="post_form/:id" element={<PermissionGuard permissionKey="posts"><PostForm /></PermissionGuard>} />
          <Route path="posts/categories" element={<PermissionGuard permissionKey="posts"><Categories /></PermissionGuard>} />
          <Route path="posts/brands" element={<PermissionGuard permissionKey="posts"><Brands /></PermissionGuard>} />
          <Route path="posts/tags" element={<PermissionGuard permissionKey="posts"><Tags /></PermissionGuard>} />
          <Route path="posts/facilities" element={<PermissionGuard permissionKey="posts"><Facilities /></PermissionGuard>} />
          <Route path="posts/comments" element={<PermissionGuard permissionKey="posts"><Comments /></PermissionGuard>} />
          <Route path="posts/addresses" element={<PermissionGuard permissionKey="posts"><Addresses /></PermissionGuard>} />

          <Route path="bookings" element={<PermissionGuard permissionKey="bookings"><Bookings /></PermissionGuard>} />

          <Route path="products" element={<PermissionGuard permissionKey="products"><Products /></PermissionGuard>} />
          <Route path="product_form" element={<PermissionGuard permissionKey="products"><ProductForm /></PermissionGuard>} />
          <Route path="product_edit/:id" element={<PermissionGuard permissionKey="products"><ProductForm /></PermissionGuard>} />
          <Route path="products/categories" element={<PermissionGuard permissionKey="products"><Categories /></PermissionGuard>} />
          <Route path="products/sub-categories" element={<PermissionGuard permissionKey="products"><SubCategories /></PermissionGuard>} />
          <Route path="products/child-categories" element={<PermissionGuard permissionKey="products"><ChildCategories /></PermissionGuard>} />
          <Route path="products/brands" element={<PermissionGuard permissionKey="products"><Brands /></PermissionGuard>} />
          <Route path="products/tags" element={<PermissionGuard permissionKey="products"><Tags /></PermissionGuard>} />
          <Route path="customers" element={<PermissionGuard permissionKey="customers"><Customers /></PermissionGuard>} />
          <Route path="coupons" element={<PermissionGuard permissionKey="coupons"><Coupons /></PermissionGuard>} />
          <Route path="seo" element={<PermissionGuard permissionKey="seo_pages"><SeoPage /></PermissionGuard>} />
          <Route path="additional_pages" element={<PermissionGuard permissionKey="additional_page"><AdditionalPages /></PermissionGuard>} />

          <Route path="WhyShopOnlinewithUs" element={<PermissionGuard permissionKey="additional_page"><WhyShopOnlineWithUs /></PermissionGuard>} />
          <Route path="OnlinePaymentMethods" element={<PermissionGuard permissionKey="additional_page"><OnlinePaymentMethods /></PermissionGuard>} />
          <Route path="AfterSalesSupport" element={<PermissionGuard permissionKey="additional_page"><AfterSalesSupport /></PermissionGuard>} />
          <Route path="FAQ" element={<PermissionGuard permissionKey="additional_page"><FAQ /></PermissionGuard>} />
          <Route path="Return&RefundPolicy" element={<PermissionGuard permissionKey="additional_page"><ReturnRefundPolicy /></PermissionGuard>} />
          <Route path="PrivacyPolicy" element={<PermissionGuard permissionKey="additional_page"><PrivacyPolicy /></PermissionGuard>} />
          <Route path="TermsandConditions" element={<PermissionGuard permissionKey="additional_page"><TermsAndConditions /></PermissionGuard>} />
          <Route path="AboutUs" element={<PermissionGuard permissionKey="additional_page"><AboutUs /></PermissionGuard>} />

          <Route path="notifications" element={<PermissionGuard permissionKey="expenses"><Notifications /></PermissionGuard>} />
          <Route path="news" element={<PermissionGuard permissionKey="expenses"><News /></PermissionGuard>} />
          <Route path="testimonials" element={<PermissionGuard permissionKey="expenses"><Testimonials /></PermissionGuard>} />
          <Route path="faqs" element={<PermissionGuard permissionKey="expenses"><Faqs /></PermissionGuard>} />
          <Route path="blogs" element={<PermissionGuard permissionKey="expenses"><Blogs /></PermissionGuard>} />
          <Route path="careers" element={<PermissionGuard permissionKey="expenses"><Careers /></PermissionGuard>} />
          <Route path="investors" element={<PermissionGuard permissionKey="expenses"><Investors /></PermissionGuard>} />
          <Route path="investor-projects" element={<PermissionGuard permissionKey="expenses"><InvestorProjects /></PermissionGuard>} />

          <Route path="expenses" element={<PermissionGuard permissionKey="expenses"><Expenses /></PermissionGuard>} />
          <Route path="expenses/categories" element={<PermissionGuard permissionKey="expenses"><ExpenseCategories /></PermissionGuard>} />
          <Route path="incomes" element={<PermissionGuard permissionKey="expenses"><Incomes /></PermissionGuard>} />
          <Route path="incomes/categories" element={<PermissionGuard permissionKey="expenses"><IncomeCategories /></PermissionGuard>} />
          <Route path="admins/list" element={<PermissionGuard permissionKey="admins"><Admins /></PermissionGuard>} />
          <Route path="landings" element={<PermissionGuard permissionKey="landing_page"><Landings /></PermissionGuard>} />
          <Route path="landing_form" element={<PermissionGuard permissionKey="landing_page"><LandingForm /></PermissionGuard>} />
          <Route path="landing/edit/:id" element={<PermissionGuard permissionKey="landing_page"><LandingForm /></PermissionGuard>} />
          <Route path="landing/page/builder/:id" element={<PermissionGuard permissionKey="landing_page"><LandingPageVvvebBuilder /></PermissionGuard>} />
          <Route path="theme/customizable" element={<PermissionGuard permissionKey="theme_customization"><ThemeCustomizables /></PermissionGuard>} />
          <Route path="theme/ready" element={<PermissionGuard permissionKey="theme_customization"><ReadyThemes /></PermissionGuard>} />
          <Route path="settings" element={<PermissionGuard permissionKey="settings"><Settings /></PermissionGuard>} />
          <Route path="settings/carousel" element={<PermissionGuard permissionKey="settings"><Carousels /></PermissionGuard>} />
          <Route path="settings/banner" element={<PermissionGuard permissionKey="settings"><Banners /></PermissionGuard>} />
          <Route path="facebook_pixel" element={<PermissionGuard permissionKey="settings"><FacebookPixels /></PermissionGuard>} />
          <Route path="google_site_setup" element={<PermissionGuard permissionKey="settings"><GoogleSiteSetups /></PermissionGuard>} />
          <Route path="payment_geteway" element={<PermissionGuard permissionKey="settings"><PaymentGeteways /></PermissionGuard>} />
          <Route path="chat_manage" element={<PermissionGuard permissionKey="settings"><ChatDatas /></PermissionGuard>} />
          <Route path="domain" element={<PermissionGuard permissionKey="settings"><Domain /></PermissionGuard>} />
          <Route path="forbidden" element={<Forbidden />} />
        </Route>

      </Routes>
    </Router>
  );
}

export default App;
